import { z } from 'zod'

// Активная фокус-сессия сотрудника (null — не в фокусе). Фокус taskless — только
// факт «в фокусе» + когда начал (presence «не беспокоить»).
export const OverviewFocusSchema = z.object({
  startedAt: z.string(),
})
export type OverviewFocus = z.infer<typeof OverviewFocusSchema>

// Открытый интервал учёта времени (null — таймер не запущен).
export const OverviewTimerSchema = z.object({
  taskId: z.string(),
  taskTitle: z.string(),
  boardId: z.string(),
  startedAt: z.string(),
})
export type OverviewTimer = z.infer<typeof OverviewTimerSchema>

// Задача в коротком списке карточки. boardName = имя доски.
export const OverviewActiveTaskSchema = z.object({
  taskId: z.string(),
  title: z.string(),
  boardId: z.string(),
  boardName: z.string(),
  projectName: z.string(),
})
export type OverviewActiveTask = z.infer<typeof OverviewActiveTaskSchema>

// Сводка по сотруднику для раздела «Сотрудники»: агрегаты времени, статус фокуса,
// открытый таймер и срез активных задач (полное число — в activeCount).
export const EmployeeOverviewSchema = z.object({
  employeeId: z.string(),
  name: z.string(),
  // Денормализованная проекция: departments — готовые ИМЕНА отделов (пусто = без отдела).
  departments: z.array(z.string()),
  totalSeconds: z.number(),
  todaySeconds: z.number(),
  focus: OverviewFocusSchema.nullable(),
  timer: OverviewTimerSchema.nullable(),
  activeCount: z.number(),
  activeTasks: z.array(OverviewActiveTaskSchema),
  completedCount: z.number(),
})
export type EmployeeOverview = z.infer<typeof EmployeeOverviewSchema>
